// libs
import React, { useState, useMemo } from 'react'
import { Box } from '@material-ui/core'

import * as S from './styles'

export type TabItem = {
  label: string
  componentChildren: React.ReactElement
  disabled?: boolean
}

type Props = {
  tabItems: TabItem[]
}

const ScrollableTabs = ({ tabItems }: Props) => {
  const [activeIndex, setActiveIndex] = useState(0)

  const handleChange = (newIndex: number) => {
    const tab = tabItems.find((_, index) => index === newIndex)
    if (tab && tab.disabled) {
      return
    }
    setActiveIndex(newIndex)
  }

  const activePanel = useMemo(() => {
    const found = tabItems.find((tab, index) => tab && index === activeIndex)

    if (found) return found.componentChildren

    return (
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <h2 style={{ color: '#525252' }}>Aba não encontrada</h2>
      </Box>
    )
  }, [activeIndex, tabItems])

  return (
    <S.Wrapper>
      <S.StyledScrollableTabs
        value={activeIndex}
        onChange={(e, v) => handleChange(v)}
        variant="scrollable"
        scrollButtons="on"
      >
        {tabItems.map((tab, idx) => (
          <S.StyledTab
            key={idx}
            label={tab.label}
            style={{
              opacity: tab.disabled ? 0.4 : 1
            }}
          />
        ))}
      </S.StyledScrollableTabs>
      <S.ActiveTabPanel>{activePanel}</S.ActiveTabPanel>
    </S.Wrapper>
  )
}

export default ScrollableTabs
